import { DynamicComponent } from 'domains/workspaceDetailDomain';
import {
  FilterTabEnum,
  JobItem,
  JobParticipantEnum,
  JobWorkflowStatusEnum,
} from 'domains/workspaceDomain';
import React, { ElementType, useMemo } from 'react';
import { RFQUploadFileWrapper } from '../components/RFQUploadFileWrapper';
import {
  CommonRFQ,
  CustomerActivity,
  CustomerFiles,
  CustomerNotes,
  CustomerProof,
  OperatorActivity,
  OperatorFiles,
  OperatorNotes,
  OperatorProof,
  OperatorRFM,
  ProducerActivity,
  ProducerFiles,
  ProducerNotes,
  ProducerProof,
  ProxyActivity,
  ProxyFiles,
  ProxyNotes,
  ProxyProof,
  CommonSummary,
  CommonShippingBilling,
} from './components';
import { BuyerQuoteFiles } from './components/customer/Files/BuyerQuoteFiles';
import './index.less';

type Props = {
  activeTab: FilterTabEnum;
  jobData: JobItem;
};

const WorkspaceItemDetail = ({ activeTab, jobData }: Props) => {
  const operator: DynamicComponent = {
    [FilterTabEnum.SUMMARY]: CommonSummary,
    [FilterTabEnum.PROOFS]: OperatorProof,
    [FilterTabEnum.FILES]: OperatorFiles,
    [FilterTabEnum.RFM]: OperatorRFM,
    [FilterTabEnum.NOTES]: OperatorNotes,
    [FilterTabEnum.ACTIVITY]: OperatorActivity,
    [FilterTabEnum.SHIPPING_BILLING]: CommonShippingBilling,
  };
  const producer: DynamicComponent = {
    [FilterTabEnum.SUMMARY]: CommonSummary,
    [FilterTabEnum.PROOFS]: ProducerProof,
    [FilterTabEnum.FILES]: ProducerFiles,
    [FilterTabEnum.NOTES]: ProducerNotes,
    [FilterTabEnum.ACTIVITY]: ProducerActivity,
    [FilterTabEnum.SUMMARY]: CommonSummary,
    [FilterTabEnum.SHIPPING_BILLING]: CommonShippingBilling,
  };
  const customer: DynamicComponent = {
    [FilterTabEnum.SUMMARY]: CommonSummary,
    [FilterTabEnum.PROOFS]: CustomerProof,
    [FilterTabEnum.FILES]: jobData.isQuote ? BuyerQuoteFiles : CustomerFiles,
    [FilterTabEnum.NOTES]: CustomerNotes,
    [FilterTabEnum.ACTIVITY]: CustomerActivity,
    [FilterTabEnum.SHIPPING_BILLING]: CommonShippingBilling,
  };
  const proxy: DynamicComponent = {
    [FilterTabEnum.SUMMARY]: CommonSummary,
    [FilterTabEnum.PROOFS]: ProxyProof,
    [FilterTabEnum.FILES]: jobData.isQuote ? BuyerQuoteFiles : ProxyFiles,
    [FilterTabEnum.NOTES]: ProxyNotes,
    [FilterTabEnum.ACTIVITY]: ProxyActivity,
    [FilterTabEnum.SHIPPING_BILLING]: CommonShippingBilling,
  };
  const rfq: DynamicComponent = {
    [JobWorkflowStatusEnum.RFQ]: CommonRFQ,
    [FilterTabEnum.FILES]: RFQUploadFileWrapper,
  };
  const detailComponent = {
    [JobParticipantEnum.OPERATOR]: operator,
    [JobParticipantEnum.PRODUCER]: producer,
    [JobParticipantEnum.CUSTOMER]: customer,
    [JobParticipantEnum.PROXY]: proxy,
    [JobWorkflowStatusEnum.RFQ]: rfq,
  };

  const errorPage = (page: ElementType, jobData: JobItem) => {
    if (page) {
      return React.createElement(page, { ...jobData, activeTab });
    } else {
      return 'error page';
    }
  };

  const participant = useMemo(() => {
    if (jobData.workflowStatus === JobWorkflowStatusEnum.RFQ) {
      return JobWorkflowStatusEnum.RFQ;
    }
    if (jobData.participants.includes(JobParticipantEnum.OPERATOR)) {
      return JobParticipantEnum.OPERATOR;
    } else if (jobData.participants.includes(JobParticipantEnum.PRODUCER)) {
      return JobParticipantEnum.PRODUCER;
    } else if (jobData.participants.includes(JobParticipantEnum.PROXY)) {
      return JobParticipantEnum.PROXY;
    } else {
      return JobParticipantEnum.CUSTOMER;
    }
  }, [jobData.participants, jobData.workflowStatus]);

  const renderDom = () => {
    if (
      Object.values({
        ...JobParticipantEnum,
        ...JobWorkflowStatusEnum,
      }).indexOf(participant) + 1
    ) {
      return errorPage(detailComponent[participant][activeTab], jobData);
    } else {
      return errorPage(
        detailComponent[JobParticipantEnum.PRODUCER][activeTab],
        jobData
      );
    }
  };
  return <div className="item-detail">{renderDom()}</div>;
};

export default WorkspaceItemDetail;
